import React, { useState, useEffect } from "react";

import { ReactComponent as RemoveIcon } from "src/asset/ic_remove_constituent_white.svg";
import { ReactComponent as RestoreIcon } from "src/asset/ic_restore_constituent_white.svg";

import styles from "./styles.module.scss";

const ConstituentsRenderer = ({ data, api, node, colDef, value }) => {
    const [counts, setCounts] = useState({ active: 0, total: 0 });

    useEffect(() => {
        if (data && data.parentId === null && node) {
            const calculateCounts = () => {
                const children = node.childrenAfterGroup || [];
                const totalCount = children.length;
                const activeCount = children.filter(
                    (child) => !child.data.isRemoved
                ).length;

                setCounts({ active: activeCount, total: totalCount });
            };

            calculateCounts();

            const onCellValueChanged = () => {
                calculateCounts();
            };

            api.addEventListener("cellValueChanged", onCellValueChanged);

            return () => {
                api.removeEventListener("cellValueChanged", onCellValueChanged);
            };
        }
    }, [data, api, node, value]);

    // For parent rows, show count of active constituents
    if (data && data.parentId === null) {
        return (
            <div className={styles.constituentsCellArea}>
                {counts.active} / {counts.total}
            </div>
        );
    }

    // For child rows, show remove/restore icon
    if (data && data.parentId !== null) {
        const handleClick = (e) => {
            e.stopPropagation();

            const newValue = !data.isRemoved;

            node.setDataValue(colDef, newValue);
        };

        return (
            <div className={styles.constituentsCellArea}>
                <button
                    className={styles.constituentToggleButton}
                    onClick={handleClick}
                    type="button"
                    title={
                        data.isRemoved
                            ? "Restore constituent"
                            : "Remove constituent"
                    }
                >
                    {data.isRemoved ? (
                        <RestoreIcon className={styles.icon} />
                    ) : (
                        <RemoveIcon className={styles.icon} />
                    )}
                </button>
            </div>
        );
    }

    return null;
};

export default ConstituentsRenderer;
